import { render, staticRenderFns } from "./phoneUs.vue?vue&type=template&id=44642533&scoped=true"
import script from "./phoneUs.vue?vue&type=script&lang=js"
export * from "./phoneUs.vue?vue&type=script&lang=js"
import style0 from "./phoneUs.vue?vue&type=style&index=0&id=44642533&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44642533",
  null
  
)

export default component.exports